export function formatMoney(value: any) {
    return `${Number(value || 0).toLocaleString('ko-KR')}원`;
}

export function formatSignedMoney(value: any) {
    const number = Number(value || 0);
    return `${number > 0 ? '+' : ''}${number.toLocaleString('ko-KR')}원`;
}

export function formatOptionalMoney(value: any) {
    return value === null || value === undefined || Number.isNaN(Number(value))
        ? '-' : formatMoney(value);
}

export function formatNumber(value: any) {
    return Number(value || 0).toLocaleString('ko-KR');
}

export function formatPrice(value: any) {
    return Number(value || 0) > 0 ? formatMoney(value) : '-';
}

export function fillAmount(fill: any) {
    return formatMoney(
        Number(fill?.quantity || 0) * Number(fill?.price || 0)
    );
}

export function formatOptionalPrice(value: any) {
    return value === null || value === undefined ? '-' : formatPrice(value);
}

export function formatPercent(value: any) {
    if (value === null || value === undefined) return '-';
    const number = Number(value);
    return `${number > 0 ? '+' : ''}${number.toFixed(2)}%`;
}

export function formatAge(value: any) {
    const seconds = Math.max(0, Number(value || 0));
    if (seconds < 60) return `${Math.round(seconds)}초`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}분`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}시간`;
    return `${Math.floor(seconds / 86400)}일`;
}

function dateTime(value: any, options: any) {
    if (!value) return '-';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul', ...options
    }).format(date);
}

export function formatKstDateTime(value: any) {
    return dateTime(value, {
        month: '2-digit', day: '2-digit', hour: '2-digit',
        minute: '2-digit', hour12: false
    });
}

export function formatTime(value: any) {
    return dateTime(value, {
        month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit'
    });
}
